import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

var ReportsHelper =
/*#__PURE__*/
function () {
  function ReportsHelper() {
    _classCallCheck(this, ReportsHelper);

    _defineProperty(this, "REPPORTS", {
      OCCUPANCY_BY: {
        label: "Occpupancy By",
        value: 1
      },
      RENT_ANALYSIS: {
        label: " Rent Analysis",
        value: 2
      },
      STATEMENTANALYSIS: {
        label: "Statement Analysis",
        value: 3
      },
      VACANCY_REPORT: {
        label: "Vacancy Report",
        value: 4
      },
      OCCUPANCY_BY_PROPERTY: {
        label: "Occupancy By Property",
        value: 5
      },
      CONGRESSIONAL_DISTRICT: {
        label: "Congressional District",
        value: 6
      },
      FINANCIAL_REPORT_CARD: {
        label: "Financial Report Card",
        value: 7
      },
      SPECIAL_NEEDS: {
        label: "Special Needs",
        value: 8
      },
      RENT_INCREASE_HISTORY: {
        label: "Rent Increase History",
        value: 9
      },
      NOI_REPORT: {
        label: "NOI Report",
        value: 10
      },
      ECONOMIC_OCCUPACNY_REPORT: {
        label: "Economic Occupancy Report",
        value: 11
      },
      ACCOUNTS_PAYABLE: {
        label: "Accounts Payable",
        value: 12
      },
      OCCUPANCY_SUMMARY: {
        label: "Occupancy Summary",
        value: 13
      }
    });
  }

  _createClass(ReportsHelper, [{
    key: "GetStatusArray",
    value: function GetStatusArray() {
      return this.REPPORTS;
    }
  }]);

  return ReportsHelper;
}();

export default new ReportsHelper();